import PhoneCountryType from "@CheckOrder/types/PhoneCountry.type";

export const emptyPhoneCountryObject: PhoneCountryType = {
    name: "",
    dialCode: "",
    isoCode: "",
}